import React from 'react';
import { Carousel } from 'react-bootstrap';

const ImageCarousel = () => {
  const images = [
    'images/carnosina_magnesio.png',
    'images/como-funciona.png',
    'images/mas_que_un_gel.png',
    'images/preg_ia.png',
    'images/tecno-transdermica.png'
  ];

  // Group images in pairs
  const groupedImages = images.reduce((acc, curr, index) => {
    if (index % 2 === 0) {
      acc.push([curr]);
    } else {
      acc[acc.length - 1].push(curr);
    }
    return acc;
  }, []);

  return (
    <section id="image-carousel" className="section bg-dark">
      <div className="container">
        <h2 className="section-title">Galería de Imágenes</h2>
        <Carousel>
          {groupedImages.map((imagePair, index) => (
            <Carousel.Item key={index}>
              <div className="row">
                {imagePair.map((image, subIndex) => (
                  <div key={subIndex} className="col-md-6">
                    <img
                      className="d-block w-100"
                      src={image}
                      alt={`Slide ${index}-${subIndex}`}
                      style={{ height: '600px', width: '800px', objectFit: 'contain' }}
                    />
                  </div>
                ))}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default ImageCarousel;